import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { ChakraProvider } from '@chakra-ui/react';

import { AppProvider, AuthProvider, useAuth } from './hooks';
import AppRoutes from './components/routes';
import { DEFAULT_EMPTY } from './main';
import { Provider } from 'react-redux';
import reduxStore from './redux/store';
import theme from './theme';
import { PwaProvider } from './pwa/PwaProvider';
import { PwaBanners } from './pwa/PwaBanners';
import { FullPageLoader } from './components/shared';

function AppShell() {
  const { loading } = useAuth();

  return (
    <>
      {loading ? <FullPageLoader /> : <AppRoutes />}
      <PwaBanners />
      <Toaster richColors position="top-right" />
    </>
  );
}

export function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
        useErrorBoundary: false
      }
    }
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={reduxStore}>
        <AuthProvider>
          <PwaProvider>
            <ChakraProvider theme={theme} resetCSS={false}>
              <AppProvider value={DEFAULT_EMPTY}>
                <AppShell />
              </AppProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </ChakraProvider>
          </PwaProvider>
        </AuthProvider>
      </Provider>
    </QueryClientProvider>
  );
}
